import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';
import { navigateToSelectedChannelRoute } from '../utils/history';
import Route from 'routes/Routes';
import { Link } from 'types/Link';
import useSnackbar from 'hooks/useSnackbar';

// eslint-disable-next-line react/display-name
const transformTagToLink = (selectedLink: Link | undefined) => (nodes: ReactNode[]) => (
  <span
    style={{ cursor: 'pointer', textDecoration: 'underline', display: 'inline' }}
    onClick={() => navigateToSelectedChannelRoute(selectedLink, Route.PROFILE)}
  >
    {nodes}
  </span>
);

const useNoWebUserLinkSnackbar = (selectedLink : Link) => {
  const { errorSnackbar } = useSnackbar();

  return () => errorSnackbar(
    <FormattedMessage
      id="channelLink.noWebUserLinkAlertMessage"
      values={{
        a: transformTagToLink(selectedLink),
      }}
    />,
  );
}

export default useNoWebUserLinkSnackbar;